export const WEATHER_CLOUD_ICON: string =
  "https://openweathermap.org/img/wn/02d@2x.png";
